/**
 * Created by vetal on 15.11.16.
 */
define('plugin/google-translate/GoogleTranslatePlugin',['require','lib/plugin/PluginAbstract','plugin/google-translate/model/GoogleTranslateModel','plugin/google-translate/view/GoogleTranslateModuleIndexView'],function (require) {

    var PluginAbstract = require('lib/plugin/PluginAbstract');
    var GoogleTranslateModel = require('plugin/google-translate/model/GoogleTranslateModel');
    var GoogleTranslateModuleIndexView = require('plugin/google-translate/view/GoogleTranslateModuleIndexView');

    return PluginAbstract.extend({

        _model : null,
        _googleTranslateModuleRegions: {
            googleTranslate: '#sb_google_translate'
        },
        _moduleView: null,
        _commonView: null,
        _gtLibReady: false,


        initialize: function () {
            var _this = this;
            this._model = new GoogleTranslateModel();

            if(window.define) {
                window.define.amd = null;
            }

            // load google translate lib
            requirejs(['google_translate'], function () {
                var attempts = 0;
                var maxAttempts = 10;
                // wait for the google translate lib to become ready
                // since it's loaded async and needs some time to initialize
                _this.intervalTimer = setInterval(function () {
                    if (window.google && window.google.translate && window.google.translate.TranslateElement) {
                        _this._gtLibReady = true;
                        clearInterval(_this.intervalTimer);
                        _this._showGoogleTranslate();
                        return;
                    }

                    if (++attempts >= maxAttempts) {
                        clearInterval(_this.intervalTimer);
                    }
                }, 300);
            });
        },

        _showGoogleTranslate: function(){
            var view = this._commonView;
            // if view is destroyed or not rendered yet or google translate lib is not ready - do nothing
            if(!view || view.isDestroyed || !this._gtLibReady){
                return;
            }
            // if google translate lib is ready and view is rendered - show google translate
            if (view.googleTranslate.$el.length) {
                if (!this._moduleView || this._moduleView.isDestroyed) {
                    this._moduleView = new GoogleTranslateModuleIndexView({
                        model : this._model
                    });
                    this._model.fetch();
                }
                view.googleTranslate.show(this._moduleView);
            }
        },

        initModules: function (view) {
            _.each(this._googleTranslateModuleRegions, function (selector, googleTranslateModuleRegion) {
                view.addRegion(googleTranslateModuleRegion, selector);
            });
            this._commonView = view;
            this._showGoogleTranslate();
        }
    });

});
